<template>
    <div class="table-search">
        <img src="../../assets/img/icon/search_gray.svg" alt="">
        <input v-model="filterWord" placeholder="搜尋" type="text">
        <img v-show="hasWord" class="clear" @click="clearAll" src="../../assets/img/icon/input_clear_all.svg" alt="">
    </div>
</template>
<script>
export default {
    data () {
        return {
            filterWord: '',
            hasWord: false
        }
    },
    props: {
        setDefault: Boolean,
        setWord: String
    },
    watch: {
        filterWord: function () {
            if( this.filterWord.length > 0 ){
                this.hasWord = true
            }else{
                this.hasWord = false
            }
            this.$emit('changeWord', this.filterWord);
            this.$emit('input', this.filterWord);
        },
        setDefault: function () {
            if(this.setDefault == true){
                this.filterWord = ''
            }
        },
        setWord: {
            handler: function (val) {
                if(val){
                    this.filterWord = val
                }
            },
            immediate: true
        }
    },
    methods: {
        clearAll: function () {
            this.filterWord = ''
            this.hasWord = false
        }
    }
}
</script>
<style lang="scss"  >
    .table-search{
        position: relative;
        display: flex;
        align-items: center;
        width: 230px;
        height: 44px;
        img{
            position: absolute;
            left: 8px;
        }
        input{
            width: 100%;
            padding-left: 36px;
            // height: 17px;
        }
        .clear{
            cursor: pointer;
            left: unset;
            right: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/TableSearch.vue